import { render, staticRenderFns } from "./TipIcon.vue?vue&type=template&id=5f41ac88&"
import script from "./TipIcon.vue?vue&type=script&lang=js&"
export * from "./TipIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports